import { Input,Component, OnInit , ChangeDetectorRef,HostListener } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ModalController,LoadingController } from '@ionic/angular';
import { DataService } from '../../services/data.service';
// import { Storage } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import Quagga from '@ericblade/quagga2'; // ES6
import { getMainBarcodeScanningCamera } from '../../camera-access';
import { Camera } from '@capacitor/camera';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';

@Component({
  selector: 'app-add-inventory',
  templateUrl: './add-inventory.component.html',
  styleUrls: ['./add-inventory.component.scss'],
})
export class AddInventoryComponent implements OnInit {

  @Input() product_id;
  inventory_form:any = FormGroup;
  submitted = false;
  focus :any = {};
  // product_list;
  products:any={};
  isAttribute = false;
  Product_attributes;
  started;
  errorMessage;
  scanner = false
  is_scan = true;
  // Product_attributes_id;

  constructor(private barcodeScanner: BarcodeScanner, private formBuilder:FormBuilder,public loadingCtrl:LoadingController,public changeDetectorRef: ChangeDetectorRef,public modalCtrl:ModalController,public db:DataService,public storage:Storage) { }

  ngOnInit() {

    // let value = "0000000060103"
    // let data =  value.substring(8,12);
    // console.log(data)
    // this.get_pos_all_products();
    
  
    this.get_addons();
    this.initializeScanner();
    // this.get_form();
  }

  @HostListener('window:resize', ['$event'])
  private func(){
    this.db.ismobile  = this.db.checkmobile();
  }
  
  
   get_form(){
    if(!this.isAttribute){
      // console.log('form1')
      this.inventory_form = this.formBuilder.group({ 
        qty: new FormControl('', Validators.required),
        amount: new FormControl('', Validators.required),
        product: new FormControl((this.products.product_name || ''), Validators.required),
        attribute_id: new FormControl(''),
        attr_qty: new FormControl(''),
        attr_rate: new FormControl(''),
      });
    } else if(this.isAttribute){
      // console.log('form2')
      this.inventory_form = this.formBuilder.group({ 
        // qty: new FormControl(""),
        // amount: new FormControl(''),
        product: new FormControl((this.products.product_name || ''), Validators.required),
        attribute_id: new FormControl((this.products.attributes_name ||''), Validators.required),
        attr_qty: new FormControl('', Validators.required),
        attr_rate: new FormControl('', Validators.required),
      });
    }
   
  }
  
  get qty(){
    return this.inventory_form.get('qty');
  } 

  get amount(){
    return this.inventory_form.get('amount');
  } 

  get product(){
    return this.inventory_form.get('product');
  } 

  get attribute_id(){
    return this.inventory_form.get('attribute_id');
  } 

  get attr_qty(){
    return this.inventory_form.get('attr_qty');
  } 

  get attr_rate(){
    return this.inventory_form.get('attr_rate');
  } 

  // get_pos_all_products(){
  //   if(localStorage.domain_customerId != undefined){
  //   this.storage.get('selectmenu').then((val) => {
  //     this.product_list = val;
  //     this.products.product_name = this.product_list[0].item;
  //     this.products.id = this.product_list[0].name;
  //     // console.log(this.product_list)
  //     // console.log(this.products.product_name)
  //   });
  // }
  // }

  get_addons(){
    this.db.get_all_attributes()
      .subscribe(data => {
        this.Product_attributes= data.message;
        // console.log(this.Product_attributes)
        this.products.attributes_name = this.Product_attributes[0].attribute_name;
        this.products.attributes_id = this.Product_attributes[0].name;
        }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }


  choose(){
    // this.db.stack_tranfer = false;
    this.db.selected_items=[];
    this.modalCtrl.dismiss();
    this.db.search_txt = '';
    this.db.inventory_page_no =  1;
    this.db.get_values();
    // this.db.ismobile ? null : this.db.stack_tranfer = false;
  }

  

  chech_box(item){
    // this.isAttribute =! this.isAttribute;
    // this.isAttribute == true ? this.isAttribute = false : this.isAttribute = true;
    item.isAttribute == true ? item.isAttribute = false : item.isAttribute = true;
    this.request();
    // console.log('this.isAttribute',this.isAttribute)
    this.get_form();
  }

  clear_item(i){
    // console.log(i)
    this.db.selected_items.splice(i,1);
  }





  add_insert(){
    // console.log(this.inventory_form);
    // console.log(this.db.selected_items);
    let data;
    let datas:any = [];
    this.db.selected_items.map((r,i)=>{
      // console.log(r.qty)
      if(r.qty != 0 && r.qty > 0 ){
       data={  
          "source":"",
          "target":"HOwarehouse",
          "item":r.name,
          "qty":!r.attribute_id ? r.qty : '',
          "rate":!r.attribute_id ? r.price : '',
          "is_attribute":!r.attribute_id ? 0  : 1,
          "attribute_id":!r.attribute_id ? '' : r.attribute_id,
          "attribute_name":!r.attribute_id ? '' : r.attribute_html,
          "attribute_quantity":!r.attribute_id ? '' : r.qty,
          "attribute_rate":!r.attribute_id ? '' : r.price
        }
       datas.push(data);
       
      }
    });     
        // console.b(data)
         this.db.insert_stock(datas).subscribe(res=>{  
            if(res.message.status == "Success"){
              // r.qty = 0;
              this.db.alert('Product added successfully')
              this.get_values();
              this.db.selected_items=[];
              this.db.ismobile ? this.modalCtrl.dismiss() : this.db.stack_tranfer = false
            }
          })  
      }
  
      get_values(){
        if(this.db.selected_items.length != 0){
          this.db.selected_items.map(item=>{
            this.db.inventory.map(res=>{
              if(res.attribute_id){
               if(res.attribute_id == item.attribute_id){
                 res.stock = res.stock + item.qty;
                 item.qty = 0;
               }
              }else{
               if(res.name == item.name){
                 res.stock = res.stock + item.qty;
                 item.qty = 0;
               }
             }
           });   
          })
        }
      }



      // get_values() {
      //      this.db.inventory_page_no =  1;
      //      this.db.get_values();
      //  }

  
      scan(){
        this.start_scan()
        // this.scanner = true;
        // this.scaned_item();
        // this.initializeScanner();
      }

      async start_scan() {
    // console.log(check)
    this.barcodeScanner.scan().then(barcodeData => {
      console.log('Barcode data', barcodeData.text);
      // if()
      // var d = barcodeData.text;
      if (barcodeData.text) {
        // var item_sku = parseInt(barcodeData.text.substring(0, 6));
        let data =  parseInt(barcodeData.text.substring(0,6));
    this.db.search_txt = data;
    this.db.inventory_page_no =  1;
     this.get_sku(data)
        // this.get_sku_product(String(data),barcodeData.text)
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

   async get_sku_product(sku,code) {
    let loader = await this.loadingCtrl.create({ message: 'Please Wait...'});
      await loader.present();
    this.db.get_sku_product_info({ sku: sku })
      .subscribe((data: any) => {
        loader.dismiss();
        if (data.message.status != 'failed') {
          var item_sku = parseInt(code.substring(0, 6));
          var weight = parseInt(code.substring(6, 12)) / 1000;
          // let check = this.item.order_item.find(obj => obj.item_sku == String(item_sku))
          // let check_index = this.item.order_item.findIndex(obj => obj.item_sku == String(item_sku))
          let datas = this.db.selected_items.find(r=> r.sku == item_sku);
          // if (check) {
            // data.qty = 1;
            data.message.message.qty = 1
            data.message.message.attribute_html = data.message.message.attribute_description
            data.message.message.attribute_id = data.message.message.attribute_ids
            data.message.message.attribute_html = data.message.message.attribute_description
            // data.attribute_html = data.message
            datas ? this.db.added_animate.next('Scanned product is already added') : this.db.selected_items.push(data);
            // this.item.order_item[check_index].amount = this.item.order_item[check_index].base_price * (weight > 0 ? weight : 0)
            // this.item.order_item[check_index].weight = weight
          // }
         //  else
         //  {
         //    data.qty = 1;
         // this.db.selected_items.push(data);
         // loader.dismiss();
         //  }
            // this.data_new_item(data,code)
            // this.DBservice.alert('Product Not Found')
          // this.storage.set('customer_list', data.message)
        }
        else
          this.db.alert(data.message.message)
      }, error => {
        loader.dismiss();
      });
  }

  async get_sku(data){
    let loader = await this.loadingCtrl.create({ message: 'Please Wait...'});
    await loader.present();

    this.getvalues(data,loader);
  }

      close_scan(){
        this.scanner = false;
        //  started = false;
      }
      
  public initializeScanner(): Promise<void> {
    
    if (!navigator.mediaDevices || !(typeof navigator.mediaDevices.getUserMedia === 'function')) {
      this.errorMessage = 'getUserMedia is not supported. Please use Chrome on Android or Safari on iOS';
      this.started = false;
      return Promise.reject(this.errorMessage);
    }

    // enumerate devices and do some heuristics to find a suitable first camera
    return Quagga.CameraAccess.enumerateVideoDevices().then(mediaDeviceInfos => {
      const mainCamera = getMainBarcodeScanningCamera(mediaDeviceInfos);
      if (mainCamera) {
        console.log(`Using ${mainCamera.label} (${mainCamera.deviceId}) as initial camera`);
        return this.initializeScannerWithDevice(mainCamera.deviceId);
      } else {
        console.error(`Unable to determine suitable camera, will fall back to default handling`);
        return this.initializeScannerWithDevice(undefined);
      }
    })
      .catch(error => {
        this.errorMessage = `Failed to enumerate devices: ${error}`;
        this.started = false;
      });
  }

  private initializeScannerWithDevice(preferredDeviceId: string | undefined): Promise<void> {
    console.log(`Initializing Quagga scanner...`);

    const constraints: MediaTrackConstraints = {};
    if (preferredDeviceId) {
      // if we have a specific device, we select that
      constraints.deviceId = preferredDeviceId;
    } else {
      // otherwise we tell the browser we want a camera facing backwards (note that browser does not always care about this)
      constraints.facingMode = 'environment';
    }

    return Quagga.init({
      inputStream: {
        type: 'LiveStream',
        constraints,
        area: { // defines rectangle of the detection/localization area
          top: '25%',    // top offset
          right: '10%',  // right offset
          left: '10%',   // left offset
          bottom: '25%'  // bottom offset
        },
        target: document.querySelector('#scanner-container_1') ?? undefined
      },
      decoder: {
        // ean_reader
        // code_128_reader
        readers: ['code_128_reader'],
        multiple: false
      },
      // See: https://github.com/ericblade/quagga2/blob/master/README.md#locate
      locate: false
    },
      (err) => {
        if (err) {
          console.error(`Quagga initialization failed: ${err}`);
          this.errorMessage = `Initialization error: ${err}`;
          this.started = false;
        } else {
          console.log(`Quagga initialization succeeded`);
          Quagga.start();
          this.started = true;
          this.changeDetectorRef.detectChanges();
          Quagga.onDetected((res) => {
            console.log(res)
            if (res.codeResult.code) {
            //   console.log(res)
              // this.get_sku_product(res.codeResult.code);
              this.onBarcodeScanned(res.codeResult.code);
            }
          });
        }
      });
  }

  private lastScannedCode: string | undefined;
  private lastScannedCodeDate: number | undefined;

  async onBarcodeScanned(code: string) {

    // ignore duplicates for an interval of 1.5 seconds
    if(this.is_scan){
      this.is_scan = false;
     const now = new Date().getTime();
     if (code === this.lastScannedCode && ((this.lastScannedCodeDate !== undefined) && (now < this.lastScannedCodeDate + 1500))) {
       return;
     }

    setTimeout(() =>{this.loadingCtrl.dismiss(),this.is_scan = true},3500)

    // only accept articles from catalogue
    // let article = this.catalogue.find(a => a.ean === code);
    // if (!article) {
    //   if (this.acceptAnyCode) {
    //     article = this.createUnknownArticle(code);
    //   } else {
    //     return;
    //   }
    // }
    // this.shoppingCart.addArticle(article);
    // this.items = this.shoppingCart.contents;
    // this.totalPrice = this.shoppingCart.totalPrice;

    this.lastScannedCode = code;
    this.lastScannedCodeDate = now;
    this.beep();

    let data =  parseInt(this.lastScannedCode.substring(0,6));
    this.db.search_txt = data;
    this.db.inventory_page_no =  1;
    
    let loader = await this.loadingCtrl.create({ message: 'Please Wait...'});
    await loader.present();

    this.getvalues(data,loader);
      // this.scaned_item(data,loader);
    // setTimeout(() =>{this.scaned_item(data,loader)},200);
    
    }

    this.changeDetectorRef.detectChanges();
  }

  beep() {
    const audio = new Audio();
    audio.src = 'assets/beep.wav';
    audio.load();
    audio.play();
  }

  // async scannerss(value){
  //   if(this.is_scan){
  //     this.db.search_txt = value;
  //     this.db.inventory_page_no =  1;
  //     this.db.get_values();
  //     let loader = await this.loadingCtrl.create({ message: 'Please Wait...'});
  //     await loader.present();
  //     setTimeout(() =>{this.scaned_item(value,loader)},200);
  //     this.is_scan = false;
  //     setTimeout(() =>{this.loadingCtrl.dismiss(),this.is_scan = true},3000)
  //   }
  // }


  getvalues(datas,loader){
   
    if(this.db.scroll_data){
     
      let data ={
        page_no : this.db.inventory_page_no,
        page_size : 10,
        search_txt : datas
      }
      this.db.get_inventory_values(data).subscribe(r=>{ 
        if(this.db.inventory_page_no == 1){
          this.db.inventory = r['message'];
          this.scaned_item(datas,loader)
          // console.log(this.search_productss)
          // this.search_empty = this.inventory;
          this.db.scroll_data = true;
        } else{
         
          if(r['message'].length != 0){
            r['message'].map(res=>{
              this.db.inventory.push(res);
            })
            this.db.scroll_data = true;
          }else{
            this.db.scroll_data = false;
          }
        }   
      })
    }
 
  }

  scaned_item(value,loader){
   
     let data = this.db.inventory.find(r=>r.sku == value);
     if(data){
       if(this.db.selected_items.length != 0){
   
        let datas = this.db.selected_items.find(r=> r.sku == value);
        // this.db.alert('Scanned product is already added')
         data.qty = 1;
         datas ? this.db.added_animate.next('Scanned product is already added') : this.db.selected_items.push(data);
         loader.dismiss();
       }else{
         data.qty = 1;
         this.db.selected_items.push(data);
         loader.dismiss();
       }
     }else{
        //  this.db.alert('Scanned product is not available');
      this.db.added_animate.next('Scanned product is not available');
      loader.dismiss();
     }
      
  }
  


  // scaned_item(value,loader){
  //   console.log(value,);
  //    let data = this.product_list.find(r=>r.sku == value);
  //    if(data){
  //      if(this.db.selected_items.length != 0){
   
  //       let datas = this.db.selected_items.find(r=> r.sku == value);
  //       // this.db.alert('Scanned product is already added')
  //        data.qty = 1;
  //        datas ? this.db.added_animate.next('Scanned product is already added') : this.db.selected_items.push(data);
  //        loader.dismiss()
  //      }else{
  //        data.qty = 1;
  //        this.db.selected_items.push(data);
  //        loader.dismiss()
  //      }
  //    }else{
  //     //  this.db.alert('Scanned product is not available');
  //     this.db.added_animate.next('Scanned product is not available');
  //     loader.dismiss()
  //    }
      
  // }
  

  get_pos_all_products(){
    if(localStorage['domain_customerId'] != undefined){
    this.storage.get('selectmenu').then((val) => {
      // this.product_list = val;
      // this.scaned_item();
    });
    
  }

}

 public async request() {
   await Camera.requestPermissions();
   console.log("request",  await Camera.requestPermissions());
 }
  
}
